<template>
  <section class="pt-0" :id="'suite-' + this.$router.currentRoute.params.name">
    <HeaderModule :title="$t('title')" :color="color" />
    <div class="container">
      <div class="columns">
        <article class="column">
          <br />
          <p class="is-size-5">{{ $t("intro") }}</p>
          <br />
        </article>
      </div>
      <div class="columns">
        <article class="column">
          <h5 class="is-size-4">{{ $t("aboutTitle") }}</h5>
          <p
            class="panel-block"
            v-for="(item, index) in $t('about')"
            :key="index"
          >
            {{ item }}
          </p>
        </article>
      </div>
      <div class="columns is-multiline">
        <article class="column is-8">
          <h5 class="is-size-4">{{ $t("functionsTitle") }}</h5>
          <div v-for="(item, index) in $t('functions')" :key="index">
            <div class="panel">
              <b>{{ item.title }}</b>
              <p class="panel-block" v-for="(p, i) in item.ctx" :key="i">
                <span class="panel-icon">
                  <i
                    class="fas fa-circle"
                    :style="`vertical-align: sub;color:${color}`"
                  ></i>
                </span>
                {{ p }}
              </p>
            </div>
            <br />
          </div>
        </article>
        <aside class="column">
          <img src="@/assets/pe.png" alt="aside" />
        </aside>
      </div>
      <article class="column">
        <h5 class="is-size-4">{{ $t("BenefitsTitle") }}</h5>
        <div class="panel">
          <p class="panel-block" v-for="(item, i) in $t('Benefits')" :key="i">
            <img
              :src="getIcon(i)"
              :alt="'icon-' + i"
              style="vertical-align: sub;height:60px;margin: 20px"
            />
            {{ item }}
          </p>
        </div>
        <div class="columns"></div>
      </article>
      <div class="columns">
        <article class="column">
          <br />
          <h5 class="is-size-3 is-italic is-bold has-text-centered">
            {{ $t("copy") }}
          </h5>
          <br />
        </article>
      </div>
    </div>
    <FooterModule />
  </section>
</template>
<script>
import FooterModule from "@/components/FooterModules.vue";
import HeaderModule from "@/components/HeaderModules.vue";
export default {
  name: "suite",
  data() {
    return {
      color: "#00ade5",
      icons: ["preview", "file", "unknown", "money"],
    };
  },
  components: { FooterModule, HeaderModule },
  methods: {
    getIcon(i) {
      let icon = this.icons[i];
      return require(`@/assets/${icon}.png`);
    },
  },
};
</script>
<i18n>
{
    "es": {
        "title": "Portal Ético",
        "intro": "Albagli Zaliasnik, firma de abogados líder en el área de Cumplimiento, y Ceptinel, líder en el sector RegTech, han desarrollado un canal de denuncias externo con el fin de entregar una solución moderna y eficiente para sus clientes.",
				"aboutTitle": "Sobre Portal-Ético",
				"about": [
					"Portal-Ético es un Canal de Denuncias automatizado, que proporciona alertas en casos de denuncias de colaboradores, proveedores, y clientes.",
					"El usuario define el formulario de denunciante en función de opciones predefinidas.",
					"Una vez que se registra una denuncia, se envía una alerta al administrador, quien inmediatamente puede comenzar el procedimiento de gestión del caso.",
					"El administrador puede rastrear sus casos abiertos y cerrados en el panel principal."
				],
				"functionsTitle": "Funcionalidades",
				"functions": [
					{
						"title": "Configuración y Uso Formulario:",
						"ctx":[
							"Formulario configurable con elementos precargados y espacio de preguntas abiertas.",
							"El cliente define en el formulario quien es receptor de las denuncias por su parte. Se puede definir receptor secundario en caso de conflicto de interés.",
							"El denunciante puede adjuntar archivos al formulario de denuncia.",
							"El denunciante puede elegir recibir notificaciones sobre el estado de la  denuncia."
						]
					},
					{
						"title": "Gestión del Caso en Sistema Ceptinel:",
						"ctx":[
							"Se crea caso en sistema  de Ceptinel automáticamente con la denuncia",
							"El usuario puede actualizar estado del caso",
							"El denunciante puede consultar Estado Caso",
							"Crear perfiles por usuario"
						]
					}
				],
				"BenefitsTitle":"BENEFICIOS PORTAL ÉTICO",
				"Benefits":[					
					"Prevención: Contar con una línea de denuncia le permite a la empresa anticiparse y poder solucionar proactivamente eventuales casos que no cumplen con las definiciones de cumplimiento y ética de las organizaciones.",
					"Confidencialidad: Nuestro canal de denuncia garantiza el total anonimato del denunciante, tanto si es empleado, proveedor o cliente.",
					"Múltiples Denuncias: Un canal de denuncia permite no solo, revelar delitos financieros, sino que también se utilizan para informar sobre casos de violencia, acoso sexual, mobbing, mala atención, robos internos y más.",
					"Ahorro en costos: A través del uso del canal de denuncias las organizaciones se pueden anticipar a eventuales situaciones que puedan significar altos costos o multas de los reguladores."
				],
				"copy":"¡CONSULTE SOBRE LOS PLANES DISPONIBLES!"
    },
    "en": {
       "title": "Ethical Portal",
        "intro": "Albagli Zaliasnik, a leading law firm in the Compliance area, and Ceptinel, a leader in the RegTech sector, have developed an external reporting channel in order to provide a modern and efficient solution for their clients.",
				"aboutTitle": "About Ethical-Portal",
				"about": [
					"Portal-Ético is an automated Complaints Channel, which provides alerts in cases of complaints from collaborators, suppliers, and customers.",
					"The user defines the whistleblower form based on predefined options.",
					"Once a complaint is registered, an alert is sent to the administrator, who can immediately start the case management procedure",
					"The admin can track his open and closed cases on the main dashboard."
				],
				"functionsTitle": "Features",
				"functions": [
					{
						"title": "Configuration and Use Form",
						"ctx":[
							"Configurable form with preloaded elements and space for open questions.",
							"The client defines in the form who is the recipient of the complaints on his part. Secondary receiver can be defined in case f conflict of interest.",
							"The complainant can attach files to the complaint form.",
							"The complainant can choose to receive notifications about the status of the complaint."
						]
					},
					{
						"title": "Case Management in the Ceptinel System:",
						"ctx":[
							"A case is automatically created in the Ceptinel system with the complaint",
							"User can update case status",
							"The complainant can check Case Status",
							"Create profiles by user"
						]
					}
				],
				"BenefitsTitle":"ETHICAL PORTAL BENEFITS",
				"Benefits":[					
					"Prevention: Having a reporting line allows the company to anticipate and be able to proactively solve eventual cases that do not meet the definitions of compliance and ethics of the organizations.",
					"Confidentiality: Our reporting channel guarantees the total anonymity of the complainant, whether they are an employee, supplier or customer.",
					"Multiple Complaints: A complaint channel allows not only to reveal financial crimes, but it is also used to report cases of violence, sexual harassment, mobbing, poor service, internal theft and more.",
					"Cost savings: Through the use of the complaints channel, organizations can anticipate possible situations that may mean high costs or fines from regulators."
				],
				"copy":"ASK ABOUT AVAILABLE PLANS!"
    },
    "pt": {
        "title": "Portal Ético",
        "intro": "Albagli Zaliasnik, escritório de advocacia líder na área de Compliance, e Ceptinel, líder no setor de RegTech, desenvolveram um canal de denúncia externa para oferecer uma solução moderna e eficiente para seus clientes.",
				"aboutTitle": "Sobre o Portal Ético",
				"about": [
					"O Portal-Ético é um Canal de Reclamações automatizado, que alerta em casos de reclamações de colaboradores, fornecedores e clientes.",
					"O usuário define o formulário de denúncia com base em opções predefinidas.",
					"Uma vez registrada uma reclamação, um alerta é enviado ao administrador, que pode iniciar imediatamente o procedimento de gerenciamento de casos.",
					"O administrador pode rastrear seus casos abertos e fechados no painel principal."
				],
				"functionsTitle": "Recursos",
				"functions": [
					{
						"title": "Formulário de Configuração e Uso:",
						"ctx":[
							"Formulário configurável com elementos pré-carregados e espaço para perguntas abertas.",
							"O cliente define no formulário quem é o destinatário das reclamações de sua parte. O receptor secundário pode ser definido em caso de conflito de interesses.",
							"O reclamante pode anexar arquivos ao formulário de reclamação.",
							"O reclamante pode optar por receber notificações sobre o andamento da reclamação."
						]
					},
					{
						"title": "Gestão de Casos no Sistema Ceptinel:",
						"ctx":[
							"Um caso é criado automaticamente no sistema Ceptinel com a reclamação",
							"O usuário pode atualizar o status do caso",
							"O reclamante pode verificar o status do caso",
							"Criar perfis por usuário"
						]
					}
				],
				"BenefitsTitle":"BENEFÍCIOS DO PORTAL ÉTICO",
				"Benefits":[					
					"Prevenção: Ter uma linha de denúncias permite à empresa antecipar e solucionar proativamente eventuais casos que não atendam às definições de compliance e ética das organizações.",
					"Confidencialidade: Nosso canal de denúncias garante o total anonimato do denunciante, seja ele funcionário, fornecedor ou cliente.",
					"Denúncias Múltiplas: Um canal de denúncias permite não apenas revelar crimes financeiros, mas também é usado para denunciar casos de violência, assédio sexual, mobbing, mau atendimento, roubo interno e muito mais.",
					"Redução de custos: Por meio do canal de reclamações, as organizações podem antecipar possíveis situações que podem significar custos elevados ou multas por parte dos reguladores."
				],
				"copy":"CONSULTE OS PLANOS DISPONÍVEIS!"
    }
}
</i18n>
